module.exports = __webpack_public_path__ + "img/horizontal_logo_xmas.886d30da.png";